import axios from "axios";

const api = axios.create({
  baseURL: "https://marathamandaldombivli.org/api",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

api.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    let res = error.response ?? error.message;
    if (res.status && res.status == 401) {
      window.location.href = "";
    }
    console.log(`some error occurred. ${res}`);
    return Promise.reject(error);
  }
);

export default api;
